import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJapanese = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_10526)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M7.99973 11.478C9.92072 11.478 11.478 9.92072 11.478 7.99973C11.478 6.07875 9.92072 4.52148 7.99973 4.52148C6.07875 4.52148 4.52148 6.07875 4.52148 7.99973C4.52148 9.92072 6.07875 11.478 7.99973 11.478Z",
				fill: "#D80027"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_10526",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgJapanese);
export { ForwardRef as ReactComponent };
